export const WATCHLIST_STATUS_QUERY_KEY = ["watchlist", "status"];
